import LangIcon from "../icons/LangIcon";


const LangSwitcher = ({ i18n, changeLanguage, iconColor='#003D3F', textColor='text-tprimary' }) => {

    return (
        <div className={`${textColor} mx-auto font-[500] text-[14px] rtl:font-[400] cursor-pointer select-none mt-[51px] w-fit whitespace-nowrap lang_switcher`} onClick={() => changeLanguage(i18n.language === 'ar' ? 'en' : 'ar')}>
            {i18n.language === 'ar' ? 'Change to English' : 'تغيير الي اللغه العربية'}
            <LangIcon color={iconColor} className={'inline-block align-middle ms-[5px]'} />
        </div>
    )

};

export default LangSwitcher;









